import { render, staticRenderFns } from "./LoginMenuButton.vue?vue&type=template&id=c33c94fe&scoped=true&"
import script from "./LoginMenuButton.vue?vue&type=script&lang=ts&"
export * from "./LoginMenuButton.vue?vue&type=script&lang=ts&"
import style0 from "./LoginMenuButton.vue?vue&type=style&index=0&id=c33c94fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c33c94fe",
  null
  
)

export default component.exports